export default {
	state: { damageCases: null, customer: null },
	getters: {
		getDamageCases(state) {
			return state.damageCases;
		},
		getCustomer(state) {
			return state.customer;
		},
	},
	mutations: {
		setDamageCases(state, payload) {
			state.damageCases = payload;
		},
		setCustomer(state, payload) {
			state.customer = payload;
		},
	},
};
